import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { getLeadTemperatureLabel } from '../leadsConfig';
import { getLeadTemperatureDotSx } from './leadsUi.styles';

/**
 * Punto de color del nivel de interés (Caliente / Tibio / Frío).
 * Misma UI que las cards del panel de Leads. Sin temperatura → null.
 *
 * @param {{
 *   temperature?: string|null,
 *   testId?: string,
 *   tooltipPlacement?: string,
 * }} props
 */
export default function LeadTemperatureDot({
  temperature = null,
  testId = 'lead-temperature',
  tooltipPlacement = 'top',
}) {
  const label = getLeadTemperatureLabel(temperature);
  if (!label) return null;
  return (
    <Tooltip title={`Nivel de interés: ${label}`} placement={tooltipPlacement} arrow>
      <Box
        component="span"
        role="img"
        aria-label={`Nivel de interés: ${label}`}
        data-testid={testId}
        sx={getLeadTemperatureDotSx(temperature)}
      />
    </Tooltip>
  );
}
